<script>
  import { translation } from "../stores";
</script>
<section style="margin-top:10vh;" class="card font-semibold">
  <p class="text-2xl mb-3">{translation.end.title}</p>
  <p class="mb-1">{translation.end.text}</p>
  <p>{translation.end.bye}</p>
</section>
